import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/admin/login/page.tsx");
